export const CONSENT_VERSION = 1;
export const CONSENT_COOKIE_NAME = 'adorable_amigos_consent';
const CONSENT_MAX_AGE = 60 * 60 * 24 * 180;

export const defaultConsent = { version: CONSENT_VERSION, essential: true, analytics: false, marketing: false };

function readCookie() {
  if (typeof document === 'undefined') return null;
  const value = document.cookie.split('; ').find((entry) => entry.startsWith(`${CONSENT_COOKIE_NAME}=`))?.split('=').slice(1).join('=');
  if (!value) return null;
  try {
    const parsed = JSON.parse(decodeURIComponent(value));
    if (parsed.version !== CONSENT_VERSION || parsed.essential !== true) return null;
    return { ...defaultConsent, analytics: parsed.analytics === true, marketing: parsed.marketing === true, updatedAt: parsed.updatedAt };
  } catch { return null; }
}

export function getConsent() { return readCookie() || { ...defaultConsent }; }
export function hasStoredConsent() { return Boolean(readCookie()); }
export function hasConsent(category) { return category === 'essential' ? true : getConsent()[category] === true; }

export function setConsent(preferences) {
  const consent = { ...defaultConsent, analytics: preferences.analytics === true, marketing: preferences.marketing === true, updatedAt: new Date().toISOString() };
  if (typeof document !== 'undefined') {
    document.cookie = `${CONSENT_COOKIE_NAME}=${encodeURIComponent(JSON.stringify(consent))}; Max-Age=${CONSENT_MAX_AGE}; Path=/; SameSite=Lax`;
    window.dispatchEvent(new CustomEvent('adorable-amigos:consent-updated', { detail: consent }));
  }
  return consent;
}

export function openConsentSettings() {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event('adorable-amigos:open-cookie-settings'));
}
